<template>
  <div class="Suggestor" :class="inline ? 'Suggestor__inline' : ''">
    <div class="field has-addons has-addons-right">
      <input type="text" class="input" v-model="query" v-if="!item" />
      <button
        class="button is-small"
        v-if="!item"
        :class="loading ? 'is-loading' : ''"
        @click="add"
        :disabled="!q"
      >
        <i class="fas fa-plus"></i>
      </button>
    </div>
    <div class="Suggestions" v-show="haystack.length > 0 && q && !item">
      <div class="tags">
        <span
          class="Suggestion tag"
          v-for="s in haystack"
          @click="choose(s)"
          :key="s.id"
          >{{ s.first_name }} {{ s.last_name }}</span
        >
      </div>
    </div>
    <span
      v-if="item && current"
      class="Chosen tag"
      :class="inline ? 'is-light' : 'is-primary'"
    >
      <router-link v-show="!inline" :to="`/contact/edit/${current.uuid}`"
        ><i class="fas fa-edit"></i></router-link
      >&nbsp; {{ current.first_name }}&nbsp;{{ current.last_name }}
      <span class="delete is-small" @click="choose(null)"></span
    ></span>
  </div>
</template>

<script>
import { types as t } from "../../store/actions/contacts";
import {
  contactChangeKey,
  strToCommonNameFormat
} from "../../store/models/_helpers";

export default {
  name: "ContactSuggestor",
  props: {
    item: {
      required: true
    },
    partnerContext: {
      required: false,
      default: null
    },
    full_contact: {},
    inline: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      query: "",
      current: null,
      loading: false,
      haystack: []
    };
  },
  methods: {
    choose(a) {
      this.query = "";
      if (!a) {
        this.$emit("update", null);
        this.current = null;
        return;
      }
      this.current = a;
      if (!this.full_contact) {
        this.$emit("update", a.id);
      } else {
        this.$emit("update", a);
      }
    },
    async add() {
      this.loading = true;
      let newContact;
      if (!this.partnerContext) {
        newContact = await this.$store.dispatch(
          t.ADD_CONTACT,
          ...strToCommonNameFormat(this.query)
        );
      } else {
        newContact = await this.$store.dispatch(t.ADD_CONTACT_WP, {
          ...strToCommonNameFormat(this.query),
          partner_id: this.partnerContext
        });
      }
      if (!this.full_contact) {
        this.$emit("update", newContact.id);
      } else {
        this.$emit("update", newContact);
      }
      this.$root.$emit(contactChangeKey());
      this.query = "";
      this.loading = false;
    }
  },
  computed: {
    q() {
      return this.query.trim().toLowerCase();
    }
  },
  async mounted() {
    if (this.item) {
      this.current = await this.$store.dispatch(t.GET_CONTACT_BY_ID, {
        id: this.item
      });
    }
  },
  watch: {
    async q(val) {
      if (!val) {
        this.haystack = [];
        return;
      }
      if (!this.partnerContext) {
        this.haystack = await this.$store.dispatch(t.SEARCH_CONTACT, {
          query: val
        });
      } else {
        this.haystack = await this.$store.dispatch(t.SEARCH_CONTACT_WP, {
          query: val,
          partner_id: this.partnerContext
        });
      }
    },
    async item(val) {
      if (val)
        this.current = await this.$store.dispatch(t.GET_CONTACT_BY_ID, {
          id: val
        });
    }
  }
};
</script>
